import {feedback} from '@/api/feedback'

const mixin = {
  methods: {
    closeFeedbackModal () {
      feedback.feedbackInProgress = ''
    }
  },
  computed: {
    feedbackCurrentView: function () {
      return feedback.feedbackInProgress
    },
    isFeedbackModalVisible: function () {
      return !!feedback.feedbackInProgress
    }
  }
}

export default mixin
